import React, { Component } from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import AssignCoursesConquest from '../../containers/assign-courses-conquest';
import LocalStorage from '../../helpers/local-storage';
import { newCoursesAvailable } from '../../helpers/utils';
import messages from './messages';
import css from './index.scss';
import Badge from '../badge/index';
import CourseBadgeAdmin from '../course-badge-admin/course-badge-admin';
import Button from '../button/index';
import Modal from '../modal/index';
import Confirmation from '../confirmation/index';
import { Warning, Forward } from '../../helpers/icon-dictionary';
import PortalCommunication from '../../portal-comms';
import SvgIcon from '../svg-icon/svg-icon';
import AssignCoursesUPF from '../../containers/assign-courses-upf';
import AssignCoursesLegacy from '../../containers/assign-courses-legacy';
import { DEFAULT_COURSE_ID, ROLLOVER_INFO_MODAL_OPTOUT } from '../../constants';
import InfoModal from './information-modal';

class DefaultCourseMapperAdmin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedConquestYearGroup: -1,
            selectedUPFYearGroup: -1,
            selectedLegacyYearGroup: -1,
            selectedCourseType: '',
            showConfirmationModal: false,
            defaultCourses: this.props.defaultCourses,
            upfCourses: this.props.upfCourses,
            conquestCourses: this.props.conquestCourses,
            disableSave: true,
            disableCancel: true,
            disableAssignToGroup: true,
            disableConquestAssignToGroup: true,
            disableUPFAssignToGroup: true,
            disableLegacyAssignToGroup: true,
            selectedConquestCourse: { id: -1, name: '' },
            selectedUPFCourse: { id: DEFAULT_COURSE_ID, name: '' },
            selectedLegacyCourse: { id: -1, name: '' },
            showConquestCourseSelector: false,
            showUPFCourseSelector: false,
            showLegacyCourseSelector: false,
            showInfoModal: false
        };
    }

    getFilteredCourses = (filtered, course) => {
        if (course.isSelected) {
            filtered.push({
                yearGroupEnum: course.yearGroupId,
                courseId: course.newCourseId
            });
        }
        return filtered;
    }

    saveCourses = () => {
        this.setState({ showInfoModal: false });

        const updatedUPFCourses =
        Array.isArray(this.state.upfCourses) && this.state.upfCourses.reduce((filtered, course) => this.getFilteredCourses(filtered, course), []);

        const updatedLegacyCourses =
        this.state.defaultCourses.reduce((filtered, course) => this.getFilteredCourses(filtered, course), []);
        const updatedConquestCourses =
            this.state.conquestCourses.reduce((filtered, course) => this.getFilteredCourses(filtered, course), []);
        this.props.handleOnSave({
            defaultCourses: updatedLegacyCourses,
            upfCourses: updatedUPFCourses || [],
            conquestCourses: updatedConquestCourses || []
        });
    }

    handleQueueCourses = () => {
        const currentSelection = LocalStorage.getItem(ROLLOVER_INFO_MODAL_OPTOUT);
        if (!currentSelection) {
            this.setState({
                showInfoModal: true
            });
            return;
        }
        this.saveCourses();
    }

    handleOnUPFCourseSelection = (yearGroupId, courseType) => {
        const { showUPFCourseSelector, selectedUPFYearGroup } = this.state;

        this.setState({
            selectedUPFYearGroup: yearGroupId,
            selectedCourseType: courseType,
            showUPFCourseSelector: selectedUPFYearGroup === yearGroupId ? !showUPFCourseSelector : true,
            showLegacyCourseSelector: false,
            showConquestCourseSelector: false
        });
    }

    handleOnLegacyCourseSelection = (yearGroupId, courseType) => {
        const { showLegacyCourseSelector, selectedLegacyYearGroup } = this.state;

        this.setState({
            selectedLegacyYearGroup: yearGroupId,
            selectedCourseType: courseType,
            showUPFCourseSelector: false,
            showLegacyCourseSelector: selectedLegacyYearGroup === yearGroupId ? !showLegacyCourseSelector : true,
            showConquestCourseSelector: false
        });
    }

    handleOnNewCoursesCourseSelection = (yearGroupId, courseType) => {
        const { showConquestCourseSelector, selectedConquestYearGroup } = this.state;

        this.setState({
            selectedConquestYearGroup: yearGroupId,
            selectedCourseType: courseType,
            showConquestCourseSelector: selectedConquestYearGroup === yearGroupId ? !showConquestCourseSelector : true,
            showUPFCourseSelector: false,
            showLegacyCourseSelector: false
        });
    }

    getRowClass = (yearGroupId) => {
        const {
            selectedUPFYearGroup,
            selectedLegacyYearGroup,
            selectedConquestYearGroup,
            selectedCourseType
        } = this.state;

        if (
            (yearGroupId === selectedUPFYearGroup && selectedCourseType === 'upf') ||
            (yearGroupId === selectedLegacyYearGroup && selectedCourseType === 'legacy') ||
            (yearGroupId === selectedConquestYearGroup && selectedCourseType === 'newCourses')
        ) {
            return css.courseSelected;
        }
        return css.courseUnselected;
    }

    renderRowBadge = ({ isSelected, yearGroupId, yearGroupName }) => (
        <div className={css.yearRow}>
            <CourseBadgeAdmin background={isSelected ? css.yearSelected : css.yearUnselected}>
                <Badge
                    badgeStyle={`${css.yearGroup} yg${yearGroupId}`}
                    content={yearGroupName}
                />
            </CourseBadgeAdmin>
        </div>
    )

    renderLearningModuleRow = ({ className, onClick, message, isVisible = true }) => {
        if (!isVisible) return null;

        return (
            <div
                className={className}
                onClick={onClick}
                role="button"
                tabIndex="-1">
                <div className={css.forwardButton}><SvgIcon icon={Forward} /></div>
                <div className={css.learningModuleText}>{message}:</div>
            </div>
        );
    }

    renderCourseBlock = ({
        className,
        isSelected,
        textContent,
        shouldRender
    }) => {
        const { intl } = this.props;

        if (!shouldRender) return null;

        return (
            <div className={className}>
                {textContent}
                {isSelected && ` ${intl.formatMessage(messages.unconfirmed)}`}
            </div>
        );
    };

    getUpfCourseText = ({ course }) => {
        const { intl } = this.props;

        if (
            !course ||
            course.courseName === undefined ||
            (course.courseId === DEFAULT_COURSE_ID && course.courseName === '')
        ) {
            return intl.formatMessage(messages.noUPFCourseSet);
        }

        return course.courseName;
    }


    renderRows = () => {
        let rows;
        const { intl } = this.props;
        const {
            selectedUPFYearGroup,
            selectedLegacyYearGroup,
            selectedConquestYearGroup,
            showUPFCourseSelector,
            showConquestCourseSelector,
            showLegacyCourseSelector,
            defaultCourses,
            upfCourses,
            conquestCourses
        } = this.state;

        if (defaultCourses) {
            rows = defaultCourses.map((val) => {
                const rowStyle = this.getRowClass(val.yearGroupId);
                const upfCourse = Array.isArray(upfCourses) && upfCourses.find(course => course.yearGroupId === val.yearGroupId);
                const conquestCourse = Array.isArray(conquestCourses) && conquestCourses.find(course => course.yearGroupId === val.yearGroupId);
                const isNewCoursesAvailable = newCoursesAvailable(val.yearGroupId);

                return (
                    <div className={css.row} key={val.yearGroupId}>
                        {this.renderRowBadge({
                            isSelected:
                                (showLegacyCourseSelector && val.yearGroupId === selectedLegacyYearGroup) ||
                                (showUPFCourseSelector && val.yearGroupId === selectedUPFYearGroup) ||
                                (showConquestCourseSelector && val.yearGroupId === selectedConquestYearGroup),
                            yearGroupId: val.yearGroupId,
                            yearGroupName: val.yearGroupName
                        })}
                        <div className={css.learningModuleRow}>
                            {this.renderLearningModuleRow({
                                className: `${css.courses} ${showLegacyCourseSelector && rowStyle}`,
                                onClick: () => this.handleOnLegacyCourseSelection(val.yearGroupId, 'legacy'),
                                message: intl.formatMessage(messages.coursesActivityMastery)
                            })}
                            {this.renderLearningModuleRow({
                                className: `${css.upf} ${showConquestCourseSelector && rowStyle}`,
                                onClick: () => this.handleOnNewCoursesCourseSelection(val.yearGroupId, 'newCourses'),
                                message: intl.formatMessage(messages.newCourses),
                                isVisible: isNewCoursesAvailable
                            })}
                            {this.renderLearningModuleRow({
                                className: `${css.upf} ${showUPFCourseSelector && rowStyle}`,
                                onClick: () => this.handleOnUPFCourseSelection(val.yearGroupId, 'upf'),
                                message: intl.formatMessage(messages.skillQuests)
                            })}
                        </div>
                        <div className={css.currentCourseRow}>
                            {this.renderCourseBlock({
                                className: `${css.defaultCourse} ${showLegacyCourseSelector && rowStyle}`,
                                isSelected: !!(val && val.isSelected),
                                textContent: val && val.courseName ? val.courseName : '',
                                shouldRender: true
                            })}
                            {this.renderCourseBlock({
                                className: `${css.defaultCourse} ${showConquestCourseSelector && rowStyle}`,
                                isSelected: !!(conquestCourse && conquestCourse.isSelected),
                                textContent: conquestCourse && conquestCourse.courseName ? conquestCourse.courseName : '',
                                shouldRender: isNewCoursesAvailable
                            })}
                            {this.renderCourseBlock({
                                className: `${css.upfDefaultCourse} ${showUPFCourseSelector && rowStyle}`,
                                isSelected: !!(upfCourse && upfCourse.isSelected),
                                textContent: this.getUpfCourseText({ course: upfCourse }),
                                shouldRender: true
                            })}
                        </div>
                    </div>
                );
            });
        }

        return rows;
    }

    handleOnClose = () => {
        this.setState({ showConfirmationModal: false });
    }

    handleOnConfirm = () => {
        this.setState(
            {
                disableSave: true,
                showConfirmationModal: false,
                selectedUPFYearGroup: -1,
                selectedLegacyYearGroup: -1,
                selectedConquestYearGroup: -1,
                selectedCourseType: '',
                selectedConquestCourse: { id: -1, name: '' },
                selectedUPFCourse: { id: DEFAULT_COURSE_ID, name: '' },
                selectedLegacyCourse: { id: -1, name: '' },
                defaultCourses: this.props.defaultCourses,
                upfCourses: this.props.upfCourses,
                conquestCourses: this.props.conquestCourses,
                disableConquestAssignToGroup: true,
                disableUPFAssignToGroup: true,
                disableLegacyAssignToGroup: true,
                showConquestCourseSelector: false,
                showUPFCourseSelector: false,
                showLegacyCourseSelector: false,
                disableAssignToGroup: true
            });
    }

    handleOnCancel = () => {
        const { defaultCourses, upfCourses, conquestCourses } = this.state;

        const hasSelectedCourses = [defaultCourses, upfCourses, conquestCourses]
            .some(courses => courses.some(course => course.isSelected));

        if (!hasSelectedCourses) {
            PortalCommunication.navigateToLandingScreen('Course admin');
        } else {
            this.setState({ showConfirmationModal: true });
        }
    }

    onUPFCourseSelect = (course, disableAssignToGroup = false) => {
        this.setState({
            selectedUPFCourse: course,
            disableUPFAssignToGroup: disableAssignToGroup
        });
    }

    onConquestCourseSelect = (course, disableAssignToGroup = false) => {
        this.setState({
            selectedConquestCourse: course,
            disableConquestAssignToGroup: disableAssignToGroup
        });
    }


    onLegacyCourseSelect = (course, disableAssignToGroup = false) => {
        this.setState({
            selectedLegacyCourse: course,
            disableLegacyAssignToGroup: disableAssignToGroup
        });
    }

    assignToUPFYearGroup = () => {
        const { upfCourses, selectedUPFYearGroup, selectedUPFCourse } = this.state;
        const isYearExisting = upfCourses.find(course => course.yearGroupId === selectedUPFYearGroup);
        let courses;

        if (!isYearExisting) {
            // In case there is no default course set for the UPF courses, the year group of that UPF course won't exist
            courses = [...upfCourses, {
                courseId: DEFAULT_COURSE_ID,
                isSelected: true,
                newCourseId: selectedUPFCourse.id,
                newCourseName: selectedUPFCourse.name,
                yearGroupId: selectedUPFYearGroup,
                yearGroupName: selectedUPFYearGroup.toString()
            }];
        } else {
            courses = upfCourses.map((course) => {
                if (course.yearGroupId === selectedUPFYearGroup) {
                    return {
                        ...course,
                        isSelected: true,
                        newCourseId: selectedUPFCourse.id,
                        newCourseName: selectedUPFCourse.name
                    };
                }
                return course;
            });
        }

        this.setState({
            disableSave: false,
            disableUPFAssignToGroup: true,
            selectedUPFCourse: { id: DEFAULT_COURSE_ID, name: '' },
            upfCourses: courses
        });
        this.props.deselectCourses();
    }

    assignToConquestYearGroup = () => {
        const { conquestCourses, selectedConquestYearGroup, selectedConquestCourse } = this.state;
        const isYearExisting = conquestCourses.find(course => course.yearGroupId === selectedConquestYearGroup);
        let courses;

        if (!isYearExisting) {
            // In case there is no default course set for the UPF courses, the year group of that UPF course won't exist
            courses = [...conquestCourses, {
                courseId: DEFAULT_COURSE_ID,
                isSelected: true,
                newCourseId: selectedConquestCourse.id,
                newCourseName: selectedConquestCourse.name,
                yearGroupId: selectedConquestYearGroup,
                yearGroupName: selectedConquestYearGroup.toString()
            }];
        } else {
            courses = conquestCourses.map((course) => {
                if (course.yearGroupId === selectedConquestYearGroup) {
                    return {
                        ...course,
                        isSelected: true,
                        newCourseId: selectedConquestCourse.id,
                        newCourseName: selectedConquestCourse.name
                    };
                }
                return course;
            });
        }

        this.setState({
            disableSave: false,
            disableConquestAssignToGroup: true,
            selectedConquestCourse: { id: DEFAULT_COURSE_ID, name: '' },
            conquestCourses: courses
        });
        this.props.deselectCourses();
    }

    assignToLegacyYearGroup = () => {
        const { defaultCourses, selectedLegacyYearGroup, selectedLegacyCourse } = this.state;

        const courses = defaultCourses.map((course) => {
            if (course.yearGroupId === selectedLegacyYearGroup) {
                return {
                    ...course,
                    isSelected: true,
                    newCourseId: selectedLegacyCourse.id,
                    newCourseName: selectedLegacyCourse.name
                };
            }
            return course;
        });

        this.setState({
            disableSave: false,
            disableLegacyAssignToGroup: true,
            selectedLegacyCourse: { id: -1, name: '' },
            defaultCourses: courses
        });
        this.props.deselectCourses();
    }

    render() {
        const { intl, savingDefaultCourses } = this.props;
        const { showConfirmationModal, showInfoModal } = this.state;

        return (
            <div>
                <InfoModal
                    handleOnSave={this.saveCourses}
                    show={showInfoModal} />
                <div className={css.panel}>
                    <div className={css.lhsPanel}>
                        <div className={css.header}>
                            <div className={css.yearColumn}>{intl.formatMessage(messages.year)}</div>
                            <div
                                className={css.learningModule}>{intl.formatMessage(messages.learningModule)}</div>
                            <div
                                className={css.currentCourseColumn}>{intl.formatMessage(messages.defaultCourse)}</div>
                        </div>
                        <div>{this.renderRows()}</div>
                    </div>
                    <div className={this.state.showUPFCourseSelector ? css.showUPFCourseSelector : css.hideUPFCourseSelector}>
                        <AssignCoursesUPF
                            disableAssignToYear={this.state.disableUPFAssignToGroup}
                            forManageDefaultCourses
                            forYear
                            handleOnCourseSelection={this.onUPFCourseSelect}
                            handleOnYearGroupSave={this.assignToUPFYearGroup}
                            isUPFSelected={this.state.showUPFCourseSelector}
                            selectedCourse={this.state.selectedUPFCourse}
                            showUPFCourseSelector={this.state.showUPFCourseSelector}
                        />
                    </div>
                    <div className={this.state.showConquestCourseSelector ? css.showUPFCourseSelector : css.hideUPFCourseSelector}>
                        <AssignCoursesConquest
                            disableAssignToYear={this.state.disableConquestAssignToGroup}
                            handleOnCourseSelection={this.onConquestCourseSelect}
                            handleOnYearGroupSave={this.assignToConquestYearGroup}
                            selectedCourse={this.state.selectedConquestCourse}
                        />
                    </div>
                    <div className={this.state.showLegacyCourseSelector ? css.showUPFCourseSelector : css.hideUPFCourseSelector}>
                        <AssignCoursesLegacy
                            assignToYearGroup={this.assignToLegacyYearGroup}
                            disableAssignToYear={this.state.disableLegacyAssignToGroup}
                            forYear
                            handleOnCourseSelection={this.onLegacyCourseSelect}
                            selectedCourse={this.state.selectedLegacyCourse}
                            showLegacyCourseSelector={this.state.showLegacyCourseSelector}
                        />
                    </div>
                </div>
                <div className={css.settingsFooter}>
                    <Button
                        containerClassName={css.cancelButton}
                        disabled={savingDefaultCourses}
                        handleOnClick={this.handleOnCancel}
                        label={intl.formatMessage(messages.cancel)}
                    />
                    <Button
                        containerClassName={css.queueButton}
                        disabled={savingDefaultCourses || this.state.disableSave}
                        handleOnClick={this.handleQueueCourses}
                        label={intl.formatMessage(messages.queue)}
                    />
                </div>
                <Modal show={showConfirmationModal}>
                    <Confirmation
                        handleOnCancel={this.handleOnClose}
                        handleOnOk={this.handleOnConfirm}
                        icon={Warning}
                        title={intl.formatMessage(messages.unsavedChanges)} />
                </Modal>
            </div>
        );
    }
}

DefaultCourseMapperAdmin.propTypes = {
    intl: intlShape.isRequired,
    defaultCourses: PropTypes.arrayOf(PropTypes.object),
    upfCourses: PropTypes.arrayOf(PropTypes.object),
    conquestCourses: PropTypes.arrayOf(PropTypes.object),
    savingDefaultCourses: PropTypes.bool,
    handleOnSave: PropTypes.func,
    deselectCourses: PropTypes.func
};

export default injectIntl(styleable(css)(DefaultCourseMapperAdmin));



// WEBPACK FOOTER //
// ./app/components/default-course-mapper-admin/index.js